import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// TODO 20230914 chatBD重新起航
// 获取获取chat bd状态历史 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120395377
export const getBDurlInfo = createAsyncThunk(
  'chatBD/hunting/getBDurlInfo',
  async (p: {uuid: string}, store: any) => {
    const resp = await http.post('/live/union/get_invite_chat_bd_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 接受邀请成为BD接口  http://wiki.xunlei.cn/pages/viewpage.action?pageId=120395368
export const acceptToBeBD = createAsyncThunk(
  'chatBD/hunting/acceptToBeBD',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/check_and_accept_chat_bd',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
// chat bd首页接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120395390
export const chat_bd_homepage = createAsyncThunk(
  'chatBD/hunting/chat_bd_homepage',
  async (p, store: any) => {
    const resp = await http.post('/live/union/chat_bd_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const getMemberInfo = createAsyncThunk(
  'chatBD/hunting/getMemberInfo',
  async (p: {show_id: string}, store: any) => {
    const resp = await http.post(
      'live/account/get_member_info_by_show_id',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
// 邀请成为团长 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120395386
export const getInviteSend = createAsyncThunk(
  'chatBD/hunting/getInviteSend',
  async (p: {target_mid: number}, store: any) => {
    const resp = await http.post(
      '/live/union/invite_union_from_chat_bd',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: false,
      }
    )
    return resp.data
  }
)
// 获取邀请成为团长信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120395444
export const getSubmitConfig = createAsyncThunk(
  'chatBD/hunting/get_create_union_config',
  async (arg: {bd_mid: number}, store: any) => {
    const resp = await http.post('/live/union/get_create_union_config', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 检查bd名是否可用 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120397481
export const check_union_name = createAsyncThunk(
  'chatBD/hunting/check_union_name',
  async (arg: {union_name: string}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        ok: boolean
      }>
    >('/live/union/check_bd_union_name', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 基本信息提交 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429516
export const apply_create_unionInfo = createAsyncThunk(
  'chatBD/hunting/apply_create_union',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/union/apply_create_union',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 支付入口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448321
export const getPayEnter = createAsyncThunk(
  'chatBD/hunting/getPayEnter',
  async (p, store: any) => {
    const resp = await http.post('/live/facetime/pay_enter', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export enum CheckStatus {
  未填写 = 0, // 未填写---可以填写
  审核已通过 = 1, // 审核已通过---不能再填写
  审核已拒绝 = 2, // 审核已拒绝---可以填写
  未审核 = 3, // 未审核---可以填写
}
export enum thresholdStatus {
  没达到最低门槛 = 0,
  达到某一门槛 = 1,
  达到最高门槛 = 2,
}

interface HuntintUnionState {
  bdurlInfo?: {
    chat_apps: Array<string>
    is_expire: boolean
  }
  chat_bd_homepage?: {
    base_salary?: number //	基础薪资
    anchor_salary?: number //	达人总薪资
    points?: number //	积分数
    rate?: number //	分成比例
    salary?: number //	薪资
    invite_union_count?: number //	本轮邀请多少团长
    good_anchor_count?: number //	本轮邀请的团长旗下有多少达到门槛的主播
    up_count?: number //	还需要6人就可以晋升下一轮 如果返回0，说明已经到达满级
    status?: thresholdStatus
  }
  get_create_union_config?: {
    // 获取邀请成为团长信息
    last_input_info?: {
      bd_mid?: number //	邀请的bd mid
      union_name?: string //	达人团名称
      name?: string //		达人团负责人姓名
      input_country?: number //	所在国家
      input_area_code?: number //	达人团区域
      chat_app?: string //		之前和哪些平台合作过
      chat_app_id?: number
      chat_app_num?: string //		联系app的号码
      is_other?: boolean // 是否用户自己填写的app
      count?: number //	达人团预期加入的达人数量
    }
    status: CheckStatus
    chat_apps?: Array<{
      app_id?: number // 唯一id
      name?: string //	app名字
      kind?: number //	1；用户自己填写的其他app
    }> // fill_app_list
    flags?: Array<{
      area_code: number
      country: string
      url?: string
      region_code: number
    }>
  }
  pay_enter?: {
    default_pay_desc: string
  }
}
const initialState: HuntintUnionState = {}

const initData: HuntintUnionState = {
  bdurlInfo: {
    chat_apps: [],
    is_expire: false,
  },
  chat_bd_homepage: {},
}

export const HuntingSlice = createSlice({
  name: 'chatBDHunting',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    // TODO cahtBD 相关内容
    builder.addCase(getBDurlInfo.fulfilled, (state, action) => {
      Object.assign(state, {bdurlInfo: action.payload})
    })
    builder.addCase(chat_bd_homepage.fulfilled, (state, action) => {
      Object.assign(state, {chat_bd_homepage: action.payload})
    })
    // 获取团长填写信息
    builder.addCase(getSubmitConfig.fulfilled, (state, action) => {
      const {last_input_info, status} = action.payload
      Object.assign(state, {
        get_create_union_config: {
          ...action.payload,
          // 如果是审核拒绝的就直接置空上次填写的全部信息
          last_input_info:
            status === CheckStatus.审核已拒绝 ? null : last_input_info,
        },
      })
    })
    builder.addCase(getPayEnter.fulfilled, (state, action) => {
      Object.assign(state.pay_enter, action.payload)
    })
  },
})

export default HuntingSlice.reducer
export const HuntingActions = HuntingSlice.actions
